import Vue from 'vue';
import VueNativeSock from 'vue-native-websocket';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;
if (process.env.VUE_APP_USE_WEBSOCKET === 'true') {
  Vue.use(VueNativeSock, 'ws://localhost:1337', {
    store,
    format: 'json',
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 5000,
  });
} else console.log('Websocket connexion desactivated.');

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
